import { useRef } from "react";
import createGuid from "../../../__internal__/utils/helpers/guid";
export default ((id, name) => {
  const createdId = useRef(createGuid());
  const createdName = useRef(createGuid());
  return [id || createdId.current, name || createdName.current];
});